import { TranslateService } from '@ngx-translate/core';
import { Injector, Input, SimpleChanges } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TmsService } from 'src/app/features/transport-operation/services/tms.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-error-tms',
  templateUrl: './error-tms.component.html',
  styleUrls: ['./error-tms.component.scss']
})
export class ErrorTmsComponent extends SessionBaseComponent implements OnInit {

  @Output() visibleChange: EventEmitter<any>;
  @Input() bookingNo!: string;

  systemError: string = "";

  isVisible: boolean = false;
  errorDatas: any[] = [];
  statusOptions: any[] = [];
  columns: any[];

  selectedTMS: any[] = [];

  constructor(
    injector: Injector,
    private tmsService: TmsService
  ) {
    super(injector);

    this.columns = [
      { field: 'doNo', header: '交貨單號' },
      { field: 'status', header: '狀態' },
      { field: 'errorMsg', header: '錯誤訊息' },
      { field: 'createDt', header: '時間' }
    ];

    this.visibleChange = new EventEmitter<any>();

    this.translateService.get('Common.TMS.SystemError').subscribe({
      next: result => {
        this.systemError = result;
      }
    });

    this.translateService.get('Common.TMS.Success').subscribe({
      next: result => {
        this.statusOptions.push({
          label: `F-${result}`,
          value: "F"
        });
      }
    });
    this.translateService.get('Common.TMS.Fail').subscribe({
      next: result => {
        this.statusOptions.push({
          label: `E-${result}`,
          value: "E"
        });
      }
    });


  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  showDialog(event: any): void {
    this.tmsService.getTMSErrorLog(this.bookingNo).subscribe({
      next: result => {
        this.errorDatas = [...result].map((x: any) => {
          var errorMsg = x.errorMsg;

          try {
            // 解析json成物件
            var specificErrMsgObj = JSON.parse(errorMsg);

            // 如果有laas格式的errorMsg，就顯示，否則顯示系統異常
            if (specificErrMsgObj.errorMsg) {
              errorMsg = specificErrMsgObj.errorMsg;
            } else {
              errorMsg = this.systemError;
            }
          } catch (err) {
            // 解析json發生錯誤，顯示系統異常
            console.log('parse tmsInErrorLog msg occur error!');
            errorMsg = this.systemError;
          }

          x.errorMsg = errorMsg;
          return x;
        });

        this.selectedTMS = [];
      }
    });
  }

  ReSendTmsBtnClick(event: any): void {
    if(this.selectedTMS.length > 0){
      var doNos = [...this.selectedTMS].map((x: any) => {
        return x.doNo;
      });
      var tmsObj = {
        bookingNo: this.bookingNo,
        doNo: doNos
      };

      this.loader.show();

      this.tmsService.reSendTms(tmsObj).subscribe({
        next: result => {
          var msg = "";
          if(result.successDos.length > 0){
            msg += `重新收取異常TMS成功: \n`;

            result.successDos.forEach((x: any) => {
              msg += `${x}\n`;
            });
          }

          if(result.failDos.length > 0){
            msg += `重新收取異常TMS失敗: \n`;

            result.failDos.forEach((x: any) => {
              msg += `${x}\n`;
            });
          }

          if(msg != ""){
            this.toastService.info(msg);
            this.showDialog(null);
          }

          this.loader.hide();
        },
        error: err => {
          this.toastErrorMessage(err.error);
          this.loader.hide();
        }
      })
    }else{
      this.toastService.info("請選取至少一個重收項目");
    }
  }
}
